import { apiSlice } from 'store/api/apiSlice';

import { IProduct } from 'shared/types/Product';

interface IProductVariantParams {
  id: string;
}

export const productVariantApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchProductVariant: builder.query<IProduct, IProductVariantParams>({
      query: ({ id }) => ({
        url: `/web-api/v1/products/${id}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useFetchProductVariantQuery } = productVariantApi;
